export const InquiryRequiredLabel = {
  functional: true,
  props: {
    text: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: true,
    },
  },
  render(h, { props }) {
    const nodes = [props.text];

    if (props.required) {
      nodes.push(
        h(
          "span",
          {
            class: "font-weight-bold",
            style: props.red ? { color: "#ea5455" } : null,
          },
          " *"
        )
      );
    }

    return h("span", nodes);
  },
};
